import { ValidationMessage, ValidationProps } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ModifiedText, TextSearchData } from './types-store';

const getTextValidationMessages = (
  validation: { [key: string]: ValidationProps },
  id: number,
  language: number,
  textSet: number
): ValidationMessage[] =>
  validation?.text?.messages
    ?.filter(message =>
      message.parameters?.id === id &&
      message.parameters?.language === language &&
      message.parameters?.textSet === textSet
    ) ?? [];

const hasValidationErrors = (
  validation: { [key: string]: ValidationProps }
): boolean => Object.keys(validation || {}).length > 0
    ? Object.keys(validation).some(key => (validation[key].messages || []).length > 0)
    : false;

export const removeValidationForText = (
  validation: { [key: string]: ValidationProps },
  text: ModifiedText
): { [key: string]: ValidationProps } => {

  if (!text || (validation?.text?.messages?.length ?? 0) === 0) {
    return hasValidationErrors(validation)
      ? validation
      : {};
  }

  const textMessages = getTextValidationMessages(validation, text.id, text.language, text.textSet);

  if (textMessages.length === 0) {
    return hasValidationErrors(validation)
      ? validation
      : {};
  }

  const updatedValidation = {
    ...validation,
    text: {
      ...(isDefinedIncludingZero(validation.text.level) && { level: validation.text.level }),
      messages: validation.text.messages.filter(
        message => !textMessages.includes(message)
      )
    }
  };

  return hasValidationErrors(updatedValidation)
    ? updatedValidation
    : {};
};

export const getComponentValidation = (
  validation: { [key: string]: ValidationProps },
  textData: TextSearchData
): string[] => {
  if (!textData) {
    return [];
  }

  return getTextValidationMessages(
    validation,
    textData.id,
    textData.language?.v,
    textData.textSet?.v
  ).map(message => message.message);
};
